"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = function _default(_ref) {
  var style = _ref.style;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    style: style,
    width: "17px",
    height: "28px",
    viewBox: "0 0 17 28"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0,2.3994 C0,1.0744 1.076,0.0004 2.4,0.0004 L14.6,0.0004 C15.926,0.0004 17,1.0804 17,2.3994 L17,25.6004 C17,26.9254 15.924,28.0004 14.6,28.0004 L2.4,28.0004 C1.074,28.0004 0,26.9194 0,25.6004 L0,2.3994 Z M8.5,26.4244 C9.154,26.4244 9.684,25.8954 9.684,25.2424 C9.684,24.5894 9.154,24.0604 8.5,24.0604 C7.846,24.0604 7.316,24.5894 7.316,25.2424 C7.316,25.8954 7.846,26.4244 8.5,26.4244 L8.5,26.4244 Z M2,22.0004 L15,22.0004 L15,2.0004 L2,2.0004 L2,22.0004 Z"
  })));
};

exports["default"] = _default;